// ─────────────────────────────────────────────────────────────
// phoneHash.js
// Produces a SHA-256 hash of a phone number for use as a
// Firestore document ID. This means phone numbers are not
// directly visible in the Firestore console document list,
// adding a layer of PII protection.
//
// The raw phone number is still stored inside the document
// (needed for sending SMS), but the document ID itself is
// a meaningless hash.
//
// Same phone number always produces the same hash, so we
// can still prevent duplicates.
// ─────────────────────────────────────────────────────────────

export const hashPhone = async (e164) => {
  const encoded = new TextEncoder().encode(e164);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // Return first 32 hex chars — enough to be unique, shorter doc ID
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 32);
};
